import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { SHELF_PATH } from '../../../../config/paths';
import PrintShelfSpaceButton from './PrintShelfSpaceButton';

const ShelfToolbar = ({ shelfId, shelf }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${SHELF_PATH}/${shelfId}/edit`} />
      <PrintShelfSpaceButton shelf={shelf} />
    </div>
  </ButtonToolbar>
);

ShelfToolbar.propTypes = {
  shelfId: PropTypes.number.isRequired,
  shelf: PropTypes.instanceOf(Object).isRequired,
};

export default ShelfToolbar;
